import styled from 'styled-components';

const InputStyle = styled.input`
    box-sizing:border-box;
    width:100%;
`

export default InputStyle;